interface ITop500IconProps {
  size?: number;
  className?: string;
}

const Top500Icon = ({ size = 47, className }: ITop500IconProps) => (
  <img
    src="/images/top500-shield.svg"
    alt="Top 500"
    width={size || 47}
    height={size || 47}
    className={className}
    style={{
      objectFit: 'contain',
      display: 'block',
    }}
  />
);

Top500Icon.defaultProps = {
  size: 47,
  className: '',
};

export default Top500Icon;
